import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'antd';
import './NewsDetail.css';

export default function NewsDetail(props) {
  const { pageName } = useParams();
  const [content, setContent] = useState('');
  const {lang} = props;
  const backHref = lang ? '/news_en' : '/news_cn';

  useEffect(() => {
    fetch(`/datas/newsContents/${pageName}/${pageName}.html`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then(data => {
        setContent(data);
      })
      .catch(error => {
        console.error('Error fetching news detail:', error);
      });
  }, [lang, pageName]);
  

  return (
    <div className="news_detail_container">
      <div className="news-content" dangerouslySetInnerHTML={{ __html: content }} />
      <p></p>
      <Button type="primary" href={backHref} style={{ margin: 'auto' }}>返回</Button>
    </div>
  );
}